import { NodeTypeName } from "@app/types";

/**
 * Get associated nodes based on the provided node's diagram flow
 * @param {string} nodeId
 * @param {array} nodes
 * @param {array} links
 * @param {array} accumulator
 * @param {array} flowPath
 * @returns {array}
 */
function getAssociatedNodes(nodeId, nodes = [], links = [], accumulator = [], flowPath = []) {
    const targetLinks = links.filter(link => link.target === nodeId);

    // track the path of links we are navigating
    flowPath.push(nodeId);

    targetLinks.forEach(({ source: sourceId }) => {
        const sourceNode = nodes.find(node => node.id === sourceId);

        if (sourceNode.props.nodeTypeName === NodeTypeName.prompt) {
            const isPromptDuplicate = accumulator.find(prompt => prompt.id === sourceId);

            if (!isPromptDuplicate) {
                accumulator.push(sourceNode);
            }
        }

        // we might hit a flow loop, so if the link was already visited before we got to stop
        if (!flowPath.includes(sourceId)) {
            getAssociatedNodes(sourceId, nodes, links, accumulator, flowPath);
        }
    });

    return accumulator;
}

export default function ExitNodes({ links, nodes }) {
    const exitNodes = {};
    const sources = [];
    const targets = [];

    // map each source and target into their own stack
    links.forEach(({ source, target }) => {
        sources.push(source);
        targets.push(target);
    });

    // search for each exit node
    nodes.forEach(node => {
        const isSource = sources.includes(node.id);
        const isTarget = targets.includes(node.id);

        // const isBeginNode = isSource && !isTarget;
        // if a node is not a source but only a target, then it is an exit node.
        const isExitNode = !isSource && isTarget;

        if (isExitNode) {
            exitNodes[node.id] = {
                exitNode: node,
                prompts: getAssociatedNodes(node.id, nodes, links)
            };
        }
    });

    return (
        <>
            <div style={{ padding: "1rem" }}>
                <strong style={{ fontSize: "1.35rem" }}>{window.l.popup.exit_values}</strong>
                <ul style={{ padding: "1rem", margin: "0 1rem", listStyle: "none" }}>
                    {Object.keys(exitNodes).length > 0
                        ? Object.entries(exitNodes).map(([exitNodeId, exitNodeData]) => {
                            const { exitNode, prompts } = exitNodeData;
                            const exitNodeIcon = `fe icon-${exitNode.props.iconClass}`;

                            return <li key={exitNodeId} style={{ marginBottom: "0.5rem" }}>
                                <i class={exitNodeIcon} style={{ paddingRight: "4px"}} />
                                {exitNode.name}
                                {prompts.length > 0 && 
                                    <ul style={{ padding: "1rem", margin: "0 1rem", listStyle: "none" }}>
                                        {prompts.map(prompt => {
                                            const promptIcon = `fe icon-${prompt.props.iconClass}`;

                                            return <li key={prompt.id} style={{ marginBottom: "0.5rem" }}>
                                                <i class={promptIcon} style={{ paddingRight: "4px"}} />
                                                {prompt.name}
                                            </li>;
                                        })}
                                    </ul>
                                }
                            </li>;
                        })
                        : "None"
                    }
                </ul>
            </div>
        </>
    );
}